export var DetailsPageOptions = {
    containerSize: 'full',
    showCategoriesNavigation: true,
    showSecondaryMarketplaceBanner: true
};
